import { render, staticRenderFns } from "./modalCopiarDestinatarios.vue?vue&type=template&id=30a0c3aa"
import script from "./modalCopiarDestinatarios.vue?vue&type=script&lang=js"
export * from "./modalCopiarDestinatarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports